import { atom } from "jotai";

export const isPaymentMethodEntryUpdatingAtom = atom(false);
